import { classNames } from 'libs/react';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { DateTime } from 'components/DateTime';
import { Image } from 'components/Image';
import './QuoteHeaderInfo.scss';
/**
 * @component QuoteHeaderInfo
 * @since 1.0.0
 */
export function QuoteHeaderInfo(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { data } = props;
    if (data == null) {
        return null;
    }
    const clientLogo = (_b = (_a = data.client) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.url;
    const contactLogo = (_d = (_c = data.contact) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.url;
    const hasLogo = clientLogo || contactLogo;
    const className = classNames('quote-header-infos', props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "quote-header-info" },
            React.createElement(Text, { className: "quote-header-info-title", value: data.type === 'AGREEMENT'
                    ? t('Agreement')
                    : data.directSale
                        ? t('Order')
                        : t('Quotation') }),
            React.createElement(Text, { className: "quote-header-info-label", value: '#' + data.number }),
            React.createElement(DateTime, { className: "quote-header-info-value", value: data.date, date: true, d: "numeric", m: "numeric", y: "numeric", style: "normal" })),
        !data.directSale && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "quote-header-info" },
                React.createElement(Text, { className: "quote-header-info-title", value: t('By') }),
                React.createElement(Text, { className: "quote-header-info-label", value: (_e = data.user) === null || _e === void 0 ? void 0 : _e.fullname }),
                React.createElement(Text, { className: "quote-header-info-value", value: ((_f = data.partner) === null || _f === void 0 ? void 0 : _f.name)
                        ? (_g = data.partner) === null || _g === void 0 ? void 0 : _g.name
                        : ((_l = (_k = (_j = (_h = data.user) === null || _h === void 0 ? void 0 : _h.contact) === null || _j === void 0 ? void 0 : _j.client) === null || _k === void 0 ? void 0 : _k.name) !== null && _l !== void 0 ? _l : (_o = (_m = data.user) === null || _m === void 0 ? void 0 : _m.account) === null || _o === void 0 ? void 0 : _o.name) })),
            React.createElement("div", { className: "quote-header-info" },
                React.createElement(Text, { className: "quote-header-info-title", value: t('For') }),
                React.createElement(Text, { className: "quote-header-info-label", value: (_p = data.contact) === null || _p === void 0 ? void 0 : _p.fullname }),
                React.createElement(Text, { className: "quote-header-info-value", value: (_q = data.client) === null || _q === void 0 ? void 0 : _q.name })))),
        hasLogo && (React.createElement("div", { className: "quote-header-contact-logo-container", onClick: () => {
                const element = document.getElementById('contact');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            } }, hasLogo ? (React.createElement(Image, { className: "quote-header-contact-logo", source: clientLogo })) : contactLogo ? (React.createElement(Image, { className: "quote-header-contact-logo", source: contactLogo })) : null))));
}
